import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from 'immer';
import { filterPayments } from "../components/PaymentSelection/components/PaymentMethodSection/utils";
import { EPaymentMethodGranular } from "../../../dependencies/getContent/constants";
import { getAllowedMethods } from "../../../dependencies/getContent/utils";
import { withLoadingLogic } from "../../../utils/utils.domain";
import { getPaymentOptionTypeFromId } from "../components/PaymentSelection/components/PaymentMethodSection/Button/logic/utils";
var sort = function sort(a, b, content) {
  var _getPaymentOptionType, _a$id, _getPaymentOptionType2, _b$id, _content$paymentMetho, _content$paymentMetho2, _content$paymentMetho3, _content$paymentMetho4;
  var _a = (_getPaymentOptionType = getPaymentOptionTypeFromId((_a$id = a.id) !== null && _a$id !== void 0 ? _a$id : '')) !== null && _getPaymentOptionType !== void 0 ? _getPaymentOptionType : EPaymentMethodGranular.Card;
  var _b = (_getPaymentOptionType2 = getPaymentOptionTypeFromId((_b$id = b.id) !== null && _b$id !== void 0 ? _b$id : '')) !== null && _getPaymentOptionType2 !== void 0 ? _getPaymentOptionType2 : EPaymentMethodGranular.Card;
  var sortA = (_content$paymentMetho = (_content$paymentMetho2 = content.paymentMethodsOptions[_a]) === null || _content$paymentMetho2 === void 0 ? void 0 : _content$paymentMetho2.sort) !== null && _content$paymentMetho !== void 0 ? _content$paymentMetho : 0;
  var sortB = (_content$paymentMetho3 = (_content$paymentMetho4 = content.paymentMethodsOptions[_b]) === null || _content$paymentMetho4 === void 0 ? void 0 : _content$paymentMetho4.sort) !== null && _content$paymentMetho3 !== void 0 ? _content$paymentMetho3 : 0;
  return sortA - sortB;
};
function toSorted(array, compareFn) {
  // Create a copy of the array using slice
  var copy = array.slice();
  // Sort the copy using the provided compare function
  copy.sort(compareFn);
  // Return the sorted copy
  return copy;
}
export var initializeUseCase = function initializeUseCase(_ref) {
  var initialize = _ref.initialize,
    getContent = _ref.getContent,
    getAccountInfo = _ref.getAccountInfo,
    getWindow = _ref.getWindow;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var _yield$withLoadingLog, options, quickOptions, content, _getAccountInfo, accountNumber, paymentMethods;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return withLoadingLogic(setState)(initialize());
          case 2:
            _yield$withLoadingLog = _context.sent;
            options = _yield$withLoadingLog.options;
            quickOptions = _yield$withLoadingLog.quickOptions;
            content = getContent();
            _getAccountInfo = getAccountInfo(), accountNumber = _getAccountInfo.accountNumber;
            paymentMethods = getAllowedMethods(getWindow, function () {
              return !!accountNumber;
            }, getContent);
            setState(function (prev) {
              return produce(prev, function (draft) {
                var _draft$quickOptions$, _draft$options$;
                draft.quickOptions = toSorted(filterPayments(quickOptions, paymentMethods), function (a, b) {
                  return sort(a, b, content);
                });
                draft.options = toSorted(filterPayments(options, paymentMethods), function (a, b) {
                  return sort(a, b, content);
                });
                draft.selectedPaymentId = ((_draft$quickOptions$ = draft.quickOptions[0]) === null || _draft$quickOptions$ === void 0 ? void 0 : _draft$quickOptions$.id) || ((_draft$options$ = draft.options[0]) === null || _draft$options$ === void 0 ? void 0 : _draft$options$.id);
                if (!accountNumber) return;
                draft.phoneInput.value = accountNumber;
              });
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};